import { BellRinging, BellSlash, PaperPlaneTilt } from "@phosphor-icons/react";

/** Botões de ação: Ativar, Enviar Teste, Desativar. */
export default function PushPermissionActions({ active, denied, busy, onEnable, onDisable, onTest }) {
  return (
    <div className="flex flex-wrap gap-2">
      {!active && (
        <button className="btn" onClick={onEnable} disabled={busy || denied} data-testid="push-enable-btn">
          <BellRinging size={16} weight="bold" />
          Ativar neste dispositivo
        </button>
      )}
      {active && (
        <>
          <button className="btn" onClick={onTest} disabled={busy} data-testid="push-test-btn">
            <PaperPlaneTilt size={16} weight="bold" /> Enviar teste
          </button>
          <button
            className="btn !bg-zinc-100 !text-zinc-800 hover:!bg-zinc-200"
            onClick={onDisable}
            disabled={busy}
            data-testid="push-disable-btn"
          >
            <BellSlash size={16} weight="bold" /> Desativar
          </button>
        </>
      )}
    </div>
  );
}
